/* 
	Author: Courageous
	Author URL: https://courageous.co.uk
*/
jQuery( window ).on( 'resize',function() {
  service_block_slider();
    // trustpilot slider
    
     
    setTimeout(function(){
     jQuery('.mobile_div_part .mobile_slider_parts .message').slick('refresh'); 
    },100)
} );

$(window).bind("load", function(){
  setTimeout(function () {
    var visibleItems = $('.collection-slider .product-list.carousel.carousel--fixed-grid-mode .owl-item.active').length;
    if(visibleItems == 3){
          console.log('truetohai');
          $('.collection-slider .hometitle').addClass('item-3-visible');
    }
    else{
        $('.collection-slider .hometitle').removeClass('item-3-visible');
    }
  }, 500)
});


(function ($) {  
  jQuery(document).ready(function(){

  
    
    setTimeout (function () {
        if( jQuery('body.night_lark_product_here').length == 1 ) {
            localStorage.removeItem('header--item');
            localStorage.setItem('header--item', jQuery('.main_top_header .nightlark_logo').data('id'));
            jQuery('body').attr('id', jQuery('.main_top_header .nightlark_logo').data('id'));
        }
    },100);

    setTimeout (function () {
      if( jQuery('body.fbc_product_here').length == 1 ) {
          localStorage.removeItem('header--item');
          localStorage.setItem('header--item', jQuery('.main_top_header .fbc_logo').data('id'));
          jQuery('body').attr('id', jQuery('.main_top_header .fbc_logo').data('id'));
      }
    },100);
    
    setTimeout (function () {
        console.log(window.location);
        var current_url = window.location.href;
        var pathname = window.location.pathname;
        if( current_url == 'https://www.finebedding.co.uk/' || pathname == '/' || pathname == '' ) {
            localStorage.removeItem('header--item');
            console.log(jQuery('.main_top_header .fbc_logo').data('id'));
            localStorage.setItem('header--item', jQuery('.main_top_header .fbc_logo').data('id'));
            jQuery('body').attr('id', jQuery('.main_top_header .fbc_logo').data('id'));
        }
    },100);

    var current_item = localStorage.getItem('header--item');
    if(current_item != null) {
      jQuery('body').attr('id', current_item);
    }
    jQuery('.main_top_header .tab--item').on('click', function() {
        jQuery('.main_top_header .tab--item').removeClass('active');
        jQuery(this).addClass('active');
        //jQuery('body').attr('id', jQuery(this).data('id'));
        if(jQuery(this).data('id') == 'nigh--lark'){
          jQuery('.desktop-only.fine-bedding-item').hide();
        }else{
          jQuery('.desktop-only.fine-bedding-item').show();
        }
        localStorage.removeItem('header--item');
        localStorage.setItem('header--item', jQuery(this).data('id'));
    });
    jQuery('.custom-header-wrapper').addClass('loaded');

    if (jQuery("body").hasClass("winter-giveaway")) {
        if(current_item == null) {
          jQuery('body').attr('id', jQuery('.main_top_header .fbc_logo').data('id'));
        }
    }
    
    // icons with text section
    jQuery('.section-icon-with-text .icon-with-text-wrapper').slick({
      dots: false,
      arrows: true,
      infinite: true,
      mobileFirst: true,
      autoplay: true,
  	  autoplaySpeed: 5000,
      slidesToShow: 3,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 820,
          settings: 'unslick'
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
      prevArrow:"<div class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'><title>Left</title><polyline points='15 18 9 12 15 6'></polyline></svg></div>",
      nextArrow:"<div class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'><title>Right</title><polyline points='9 18 15 12 9 6'></polyline></svg></div>"
    });


    // trustpilot slider
    
    //  jQuery('.mobile_div_part .mobile_slider_parts .message').slick({
    //     dots: false,
    //     arrows: true,
    //     slidesToShow: 2,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     infinite: true,
    //     adaptiveHeight: true,
    //     responsive: [
    //       {
    //         breakpoint: 768,
    //           settings: {
    //           slidesToShow: 1,
    //             slidesToScroll: 1
    //         }
    //       }
    //      ]
    // });

    jQuery('.mobile_div_part .mobile_slider_parts .message').slick({
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 769,
              settings: {
              slidesToShow: 2,
                slidesToScroll: 1
            }
          },
          {
            breakpoint: 993,
           settings: 'unslick'
          }
         ]
    });

     
    
    // product page read more link
    jQuery("a.read-more , .read-more").on("click", function(){
      	jQuery(".product-short-description , .product_desc_wrap").toggleClass("active");
    });

    if(jQuery(".addingreadmore>div").height() > 100){

      setTimeout(function(){
        if(jQuery(".addingreadmore p:first-child").length > 0){
            if(jQuery(".addingreadmore p:first-child").height() > 50){
                jQuery(".collection-read-more-btn").show();
                jQuery(".addingreadmore").addClass("collection-read-more lessheight");
            }else{
                jQuery(".collection-read-more-btn").show();
                jQuery(".addingreadmore").addClass("collection-read-more");
            }
        }else{
            jQuery(".collection-read-more-btn").show();
            jQuery(".addingreadmore").addClass("collection-read-more lessheight");
        }
        jQuery(".addingreadmore").removeClass("addingreadmore");
      }, 500);
    }else{
      jQuery(".addingreadmore").removeClass("addingreadmore");
    }
  

    jQuery("a.collection-read-more-btn").on("click", function(){
      	jQuery(".collection-read-more").toggleClass("active");
        if(jQuery(".collection-read-more").hasClass("active")){
            jQuery(".collection-read-more-btn").html("Read less");
            jQuery(".collection-read-more").css("display", 'block');
        }else{
            jQuery(".collection-read-more-btn").html("Read more");
            setTimeout(function(){
                jQuery(".collection-read-more").css("display", '-webkit-box');
            }, 900);
        }
    });
    
    jQuery(document).on("click",".product-form div[class*='rio-swatch-unavailable-']", function() {
      var vars = [], hash;
      setTimeout (function () {
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        console.log(hash[1]);
        if(hash[1] == '19733164884030') {
          console.log('yes');
          jQuery('.hide_stock').addClass('active');
          jQuery('.klaviyo-form').addClass('hide');
        } else {
          jQuery('.hide_stock').removeClass('active');
          jQuery('.klaviyo-form').removeClass('hide');
        }
      },500);
    });
    
    jQuery(document).on("click",".product_desc_parts .read-more", function() {
     jQuery(this).closest('.product_desc_parts').toggleClass('read-more');
     if(jQuery(this).closest('.product_desc_parts').hasClass('read-more')) {
      jQuery(this).text('Read less');
     } else {
      jQuery(this).text('Read more');
     }
   });

    jQuery('.header-search .searchToggle').off('click').on('click', function(){
      jQuery('.header-search').toggleClass('search-open');
      jQuery('.header-search .search-form input.input-group-field').focus();
      jQuery(".aad_search_form_mob").find("input").val("");
      jQuery(".aad_search_form_mob").find(".search-results").removeClass("aad_searched_results");
    });

    // accordion js
    jQuery(document).on('click', '.easyspecs-table .easyspecs-title-row', function(e) {
      if(jQuery(this).closest(".product-column-right").find(".product-detail-accordion .cc-accordion-item").hasClass('is-open')) {
        jQuery(this).closest(".product-column-right").find(".product-detail-accordion .cc-accordion-item").removeAttr('open');;
      }
      jQuery(this).siblings(".easyspecs-subchart-content").slideToggle("300");
      jQuery(this).closest(".easyspecs-subchart").siblings(".easyspecs-subchart").find(".easyspecs-subchart-content").slideUp("300");
      jQuery(this).toggleClass("active").closest(".easyspecs-subchart").siblings(".easyspecs-subchart").find(".easyspecs-title-row").removeClass('active');;
    });

    // accordion js
    jQuery(document).on('click', '.product-detail-accordion .cc-accordion-item', function(e) {
      jQuery(this).closest(".product-column-right").find(".easyspecs-subchart .easyspecs-title-row").removeClass('active');
      jQuery(this).closest(".product-column-right").find(".easyspecs-subchart .easyspecs-subchart-content").slideUp("300");
    });
    
  });  
})()

$(window).on('load', function () {
   // page is fully loaded, including all frames, objects and images
  jQuery(".our__story__inner:not(.first__col) .shg-row > div").appendTo(".our__story__inner.first__col .shg-row");
  jQuery('.our__story__inner.first__col .shg-row').slick({
      dots: false,
      arrows: true,
      autoplay: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: $('.our__story__heading'),
      // prevArrow:"<div class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'><title>Left</title><polyline points='15 18 9 12 15 6'></polyline></svg></div>",
      // nextArrow:"<div class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'><title>Right</title><polyline points='9 18 15 12 9 6'></polyline></svg></div>",
      responsive: [
         {
            breakpoint: 991,
            settings: {
               slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true
            }
         },
            {
              breakpoint: 768,
                settings: {
                slidesToShow: 1,
                  slidesToScroll: 1
              }
            }
           ]
   });
});

$(window).on('load', function () {
   // page is fully loaded, including all frames, objects and images
  jQuery(".nightlark-collection:not(.nightlark-firstrow) .shg-row > div").appendTo(".nightlark-collection.nightlark-firstrow .shg-row");
  jQuery('.nightlark-collection.nightlark-firstrow .shg-row').slick({
      dots: false,
      arrows: true,
      autoplay: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      appendArrows: $('.nightlark-posttitle'),
      // prevArrow:"<div class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'><title>Left</title><polyline points='15 18 9 12 15 6'></polyline></svg></div>",
      // nextArrow:"<div class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'><title>Right</title><polyline points='9 18 15 12 9 6'></polyline></svg></div>",
      responsive: [
         {
            breakpoint: 991,
            settings: {
               slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true
            }
         },
            {
              breakpoint: 768,
                settings: {
                slidesToShow: 1,
                  slidesToScroll: 1
              }
            }
           ]
   });
});


//night owl page  popular product collection add class
$(".most-poplar-section .shg-category .shg-category-grid > div:first-child").addClass("first-row");

//night owl page  popular product collection
$(window).on('load', function () {
   // page is fully loaded, including all frames, objects and images
  jQuery(".most-poplar-section .shg-category .shg-category-row .shg-category-col:empty").remove();
  jQuery(".most-poplar-section .shg-category .shg-category-row:not(.first-row) > div").appendTo(".most-poplar-section .shg-category .shg-category-row.first-row");
  jQuery('.most-poplar-section .shg-category .shg-category-row.first-row').slick({
      dots: false,
      arrows: true,
      autoplay: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
         {
            breakpoint: 940,
            settings: {
               slidesToShow: 2,
              slidesToScroll: 1,
            }
         },
            {
              breakpoint: 480,
                settings: {
                slidesToShow: 1,
                  slidesToScroll: 1
              }
            }
           ]
   });
   $('.most-poplar-section .shg-category .shg-category-row.first-row').slick('setPosition');
  setTimeout(function(){ 
     $('.service-icon-section .service-steps-container .shg-row').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 1200,
        infinite: false,
        rows: 0,
        dots: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    });
    jQuery('.most-poplar-section .shg-category .shg-category-row.first-row').slick('refresh');
  }, 1000); 
});




	// nightlark product detail page also like
$(window).on('load', function () {
$('#nigh--lark.template-product .collection-listing .product-list').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
 
  });


$('.service-icon-section .service-steps-container .shg-row').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 1200,
        infinite: false,
        rows: 0,
        dots: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    });





  var flag = false;
    function service_block_slider() {
    if($(".service_offers_block").length) {
    if ($(window).width() < 992) {
    if (!flag) {
      setTimeout(function () {
      $(".service_offers_block").not('.slick-initialized').slick({
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        fade: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        rows: 0,
        adaptiveHeight: true,
        responsive: [
          {
             breakpoint: 2500,
            settings: 'unslick',
          },
                    {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
            },
          }
        ]
      });
        }, 500);
       //$('.service_offers_block').slick('setPosition');
      //$(".service_offers_block").slick("refresh");
      flag = true;
    }
  } else {
    if (flag) {
      flag = false;
            $('.service_offers_block').slick('unslick');
    }
  }
  }
}
service_block_slider();
$(window).resize(service_block_slider);


// $(document).ready(function() {
//     if ($("body").attr("id") === "fine--bedding") {
//         setTimeout(function() {
//           $("body#fine--bedding .navigation__tier-1.mobile_menu_nighlark").remove();
//         }, 200);
//     }
// });
// $(document).ready(function() {
//     if ($("body").attr("id") === "nigh--lark") {
//         setTimeout(function() {
//           $("body#nigh--lark .desktop-only.fine-bedding-item").remove();
//         }, 200);
//     }
// });
// $(document).ready(function() {
//     if ($("body").attr("id") === "fine--bedding") {
//         setTimeout(function() {
//           $("body#fine--bedding .navigation__tier-1.mobile_menu_nighlark").remove();
//         }, 200);
//     }
// });

$(window).on('load', function () {
    setTimeout (function () {
        var $div = $('div[aria-label="cookieconsent"]');
        if ($div.length > 1) {
           $div.not(':first').remove()
        }
    },1000);
});





  




